// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.access-step-wizard {
  font-family: "72-Regular";
}

.access-step-wizard {
  width: 100%;
}
.access-step-wizard .access-step-wizard-container {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 0.5rem;
  display: table;
  table-layout: fixed;
  width: 100%;
  color: #849397;
  background-color: transparent;
  box-shadow: none;
}
.access-step-wizard .access-step-wizard-container.disableStepper {
  pointer-events: none;
  opacity: 0.5;
}
.access-step-wizard .access-step-wizard-container .step-indicator {
  position: absolute;
  color: #888;
  top: 0.8rem;
  z-index: 100;
}
.access-step-wizard .access-step-wizard-container li {
  position: relative;
  text-align: center;
  width: 20%;
  display: inline-block;
}
.access-step-wizard .access-step-wizard-container li span.circle {
  display: inline-block;
  margin: 0 auto;
  background: #DFE3E4;
  padding: 0.5rem;
  text-align: center;
  margin-bottom: 0.9rem;
  line-height: 2.2em;
  border-radius: 100%;
  position: relative;
  z-index: 100;
  cursor: pointer;
}
.access-step-wizard .access-step-wizard-container li span.circle:hover {
  background: #0a6ed1;
  border: solid 2px #0a6ed1;
  top: 0.2rem;
}
.access-step-wizard .access-step-wizard-container li:before {
  content: "";
  position: absolute;
  display: block;
  background: #DFE3E4;
  width: 100%;
  height: 2px;
  border: solid 1px #dfe3e4;
  top: 0.5rem;
  right: 50%;
  z-index: 1;
}
.access-step-wizard .access-step-wizard-container li:first-child:before {
  display: none;
}
.access-step-wizard .access-step-wizard-container li a,
.access-step-wizard .access-step-wizard-container li a:hover,
.access-step-wizard .access-step-wizard-container li a:active a:focus {
  color: inherit;
  text-decoration: none;
}
.access-step-wizard .access-step-wizard-container li.li-over:before {
  top: 0.9rem;
}
.access-step-wizard .access-step-wizard-container li.selected:before {
  border: solid 1px #0a6ed1;
}
.access-step-wizard .access-step-wizard-container li.selected span.circle {
  background: #0a6ed1;
}
.access-step-wizard .access-step-wizard-container li.selected.active:before {
  top: 0.9rem;
}
.access-step-wizard .access-step-wizard-container li.selected.active span.circle {
  border: 0.2rem solid #fff;
  box-shadow: 0 0 0 0.2rem #0a6ed1;
  background-color: #0a6ed1;
  top: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/administration/users/permissions-access-stepper/permissions-access-stepper.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AAFA;EACI,WAAA;AAKJ;AAHI;EAKE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;AACN;AAdM;EACE,oBAAA;EACA,YAAA;AAgBR;AAJM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAMR;AAJM;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;AAMR;AALQ;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAOV;AANU;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;AAQZ;AALQ;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AAOV;AALQ;EACE,aAAA;AAOV;AALQ;;;EAGE,cAAA;EACA,qBAAA;AAOV;AALQ;EACE,WAAA;AAOV;AAHQ;EACE,yBAAA;AAKV;AAHQ;EACE,mBAAA;AAKV;AADQ;EACE,WAAA;AAGV;AADQ;EACE,yBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;AAGV","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../../../assets/css/fonts';\n.access-step-wizard {\n    width: 100%;\n    @extend %font-regular;\n    .access-step-wizard-container {\n      &.disableStepper{\n        pointer-events: none;\n        opacity: 0.5;\n      }\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      padding-top: 0.5rem;\n      display: table;\n      table-layout: fixed;\n      width: 100%;\n      color: #849397;\n      background-color: transparent;\n      box-shadow: none;\n      .step-indicator {\n        position: absolute;\n        color: #888;\n        top: 0.8rem;\n        z-index: 100;\n      }\n      li {\n        position: relative;\n        text-align: center;\n        width: 20%;\n        display: inline-block;\n        span.circle {\n          display: inline-block;\n          margin: 0 auto;\n          background: #DFE3E4;\n          padding: 0.5rem;\n          text-align: center;\n          margin-bottom: 0.9rem;\n          line-height: 2.2em;\n          border-radius: 100%;\n          position: relative;\n          z-index: 100;\n          cursor: pointer;\n          &:hover{\n            background: #0a6ed1;\n            border: solid 2px #0a6ed1;\n            top: 0.2rem;\n          }\n        }\n        &:before {\n          content: '';\n          position: absolute;\n          display: block;\n          background: #DFE3E4;\n          width: 100%;\n          height: 2px;\n          border: solid 1px #dfe3e4;\n          top: 0.5rem;\n          right: 50%;\n          z-index: 1;\n        }\n        &:first-child:before {\n          display: none;\n        }\n        a,\n        a:hover,\n        a:active a:focus {\n          color: inherit;\n          text-decoration: none;\n        }\n        &.li-over:before{\n          top: 0.9rem;\n        }\n      }\n      li.selected {\n        &:before{\n          border: solid 1px #0a6ed1;\n        }\n        span.circle {\n          background: #0a6ed1;\n        }\n      }\n      li.selected.active {\n        &:before{\n          top: 0.9rem;\n        }\n        span.circle {\n          border: 0.2rem solid #fff;\n          box-shadow: 0 0 0 0.2rem #0a6ed1;\n          background-color: #0a6ed1;\n          top: 0.2rem;\n        }\n      }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
